import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {
    Button,
    Container,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead, TableRow,
    TextField
} from "@mui/material";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import "./AddEmployeeForm.css";
import AddNewPermitTypePrice from "./AddNewPermitTypePrice";
import ContenteditableFields from "./ContenteditableFields";
import PermitTypeDisplayForAdmin from "../../../components/CaseInsideTable/PermitTypeDisplayForAdmin";
import LoaderCustom from "../../../components/ConfirmationModal/LoaderCustom";
import LoaderCustomFixed from "../../../components/ConfirmationModal/LoaderCustomFixed";
import {Autocomplete} from "@mui/lab";


const AddNewFileTypeForm = ({geoIds}) => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    const idNumeric = parseInt(id, 10);
    const [fileTypes, setFileTypes] = useState([]);
    const [cities, setCities] = useState([]);
    const [title, setTitle] = useState('');
    const [maxSizeMB, setMaxSizeMB] = useState(null);
    const [extension, setExtension] = useState('');
    const [isRequired, setIsRequired] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleteFileTypeId, setDeleteFileTypeId] = useState(null);
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const [activeTab, setActiveTab] = useState('fileType');
    const [isEditing, setIsEditing] = useState(null);
    const [editableFileType, setEditableFileType] = useState({title: '', extension: '', required: true, maxSizeMB: 0});
    const [draggedItem, setDraggedItem] = useState(null);
    const [droppedItem, setDroppedItem] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);
    const [isCheck, setIsCheck] = useState(false);
    const [isInspectDocument, setIsInspectDocument] = useState(false);
    const [isInspectCertificate, setIsInspectCertificate] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedCityId, setSelectedCityId] = useState(null);
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState('');

    const fileExtensionOptions = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "csv",
        "ppt",
        "pptx",
        "txt",
        "rtf",
        "odt",
        "ods",
        "odp",
        "md",
        "markdown",
        "png",
        "jpg",
        "jpeg",
        "gif",
        "bmp",
        "tiff",
        "svg",
        "webp",
        "ico",
        "heic",
        "zip",
        "rar",
        "7z",
        "tar",
        "gz",
        "bz2",
        "xz"
    ];


    const handleInputChange = (e) => {
        const value = e.target.value;
        if (value < 1 || value > 10000) {
            setError(true);
            setHelperText('შეიყვანეთ რიცხვი 1-დან 10000-მდე');
        } else {
            setError(false);
            setHelperText('');
        }
        setMaxSizeMB(value);
    };

    const handleDragStart = (e, index) => {
        setDraggedItem(index);
    };


    useEffect(() => {
        const fetchCities = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/DictionaryTypesDetalisById?CategoryId=${geoIds.municipalityId}`);
                if (response.data && response.data.success) {
                    setCities(response.data.data.resultlist);
                }
            } catch (error) {
            }
        };
        void fetchCities();
    }, []);

    const handleDrop = async (e, dropIndex) => {
        e.preventDefault();
        if (draggedItem === null || draggedItem === dropIndex) return;

        let newFileTypes = [...fileTypes];
        const [reorderedItem] = newFileTypes.splice(draggedItem, 1);
        newFileTypes.splice(dropIndex, 0, reorderedItem);
        newFileTypes = newFileTypes.map((item, index) => ({
            ...item,
            sort: index + 1,
        }));
        setFileTypes(newFileTypes);

        try {
            const updatePromises = newFileTypes.map(fileType =>
                axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditFileType`, fileType)
            );
            await Promise.all(updatePromises);
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});
        } catch (error) {
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'error'});
            void fetchFileTypes();
        }

        setDraggedItem(null);
        setDroppedItem(null);
        setDragOverIndex(null);
    };


    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDragEnter = (e, index) => {
        setDragOverIndex(index);

    };

    const handleDragLeave = () => {
        setDragOverIndex(null);
    };

    const handleDragEnd = () => {
        setDragOverIndex(null);
    };


    useEffect(() => {
        void fetchFileTypes();
    }, [id]);


    const handleEdit = (fileType) => {
        setIsEditing(fileType.id);
        setEditableFileType({...fileType});
    };

    const handleSave = async (fileTypeId) => {
        const formattedExtensions = editableFileType.extension.split(',')
            .map(ext => ext.trim())
            .map(ext => ext.startsWith('.') ? ext : `.${ext}`)
            .join(', ');

        const updatedFileType = {
            id: fileTypeId,
            title: editableFileType.title,
            extension: formattedExtensions,
            required: editableFileType.required,
            caseId: parseInt(id, 10),
            maxSizeMB: parseInt(editableFileType.maxSizeMB, 10),
            sort: editableFileType.sort,
            cityId: editableFileType.cityId
        };

        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditFileType`, updatedFileType);
            setAlert({show: true, message: 'დოკუმენტი განახლდა', type: 'success'});
            await fetchFileTypes();
        } catch (error) {
            setAlert({show: true, message: 'შეცდომა განახლებისას!', type: 'error'});
        } finally {
            setIsEditing(null);
        }
    };

    const fetchFileTypes = async () => {
        try {
            setIsLoading(true)
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllFileTypes`);
            let filteredFileTypes = response.data.data.filter(fileType => fileType.caseId === parseInt(id));
            filteredFileTypes.sort((a, b) => a.sort - b.sort);
            setFileTypes(filteredFileTypes);
            setIsLoading(false)
        } catch (error) {
        }
    };

    const getCityNameById = (cityId) => {
        const city = cities.find(c => c.id === cityId);
        return city ? city.itemName : 'არ არის შევსებული';
    };

    const clearForm = () => {
        setTitle('');
        setExtension('');
        setIsRequired(true);
        setMaxSizeMB('');
        setSelectedCityId(null)
    };
    const openSubmitModal = (e) => {
        e.preventDefault();
        const existingCheckedFileType = fileTypes.find(fileType => fileType.isCheck);
        if (isCheck && existingCheckedFileType) {
            setAlert({show: true, message: 'დაჩქარების ქვითარი უკვე არსებობს', type: 'error'});
        } else {
            setIsModalOpen(true);
        }
    };


    const confirmSubmit = async () => {
        const formattedExtensions = extension.split(',')
            .map(ext => ext.trim())
            .map(ext => ext.startsWith('.') ? ext : `.${ext}`)
            .join(', ');

        const newFileType = {
            title,
            extension: formattedExtensions,
            required: isRequired,
            caseId: parseInt(id, 10),
            maxSizeMB: parseInt(maxSizeMB, 10),
            sort: fileTypes.length + 1,
            isCheck: isCheck,
            cityId: selectedCityId,
            registeryDocumentType: isInspectDocument ? 1 : 0,
            isinspectionSertificate: isInspectCertificate

        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewFileType`, newFileType);
            setAlert({show: true, message: 'დოკუმენტი წარმატებით დაემატა', type: 'success'});
            clearForm();
            void fetchFileTypes();
        } catch (error) {
            setAlert({show: true, message: 'დაფიხირდა შეცოდმა', type: 'error'});
        } finally {
            setIsModalOpen(false);
        }
    };


    const handleDeleteConfirm = async () => {
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteFileType`, {id: deleteFileTypeId});
            setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});

            const remainingFileTypes = fileTypes.filter(fileType => fileType.id !== deleteFileTypeId);
            remainingFileTypes.sort((a, b) => a.sort - b.sort);

            const updatePromises = remainingFileTypes.map((fileType, index) => {
                const newSortValue = index + 1;
                if (fileType.sort !== newSortValue) {
                    fileType.sort = newSortValue;
                    return axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditFileType`, {
                        ...fileType,
                        sort: newSortValue,
                    });
                }
                return Promise.resolve();
            });

            await Promise.all(updatePromises);

            setFileTypes(remainingFileTypes);

        } catch (error) {
            setAlert({show: true, message: 'Error occurred!', type: 'error'});
        } finally {
            setIsDeleteModalOpen(false);
        }
    };

    const openDeleteModal = (fileTypeId) => {
        setDeleteFileTypeId(fileTypeId);
        setIsDeleteModalOpen(true);
    };

    const isSubmitDisabled = title.trim() === '' || extension.trim() === '' || maxSizeMB === '';

    return (
        <div className="add-dov-type-form">
            <h3 className="permit-type-form">
                {idNumeric && !isNaN(idNumeric) && (<PermitTypeDisplayForAdmin id={idNumeric}/>)}
            </h3>
            <div className="tab-navigation-container">
                <div className="tab-navigation">
                    <button
                        className={activeTab === 'fileType' ? 'active-tab' : ''}
                        onClick={() => setActiveTab('fileType')}
                    >
                        ნებართვის ფაილები
                    </button>
                    <button
                        className={activeTab === 'accelerate' ? 'active-tab' : ''}
                        onClick={() => setActiveTab('accelerate')}
                    >
                        დაჩქარების პარამტრები
                    </button>
                    <button
                        className={activeTab === 'basicParams' ? 'active-tab' : ''}
                        onClick={() => setActiveTab('basicParams')}
                    >
                        ზოგადი პარამეტრები
                    </button>
                </div>
            </div>

            <div>


                {activeTab === 'fileType' ? (
                        <Container>
                            <Paper style={{padding: 16, marginRight: '16px', flexBasis: '40%'}}>

                                <form onSubmit={openSubmitModal}>
                                    <TextField
                                        label="დოკუმენტის სახელი"
                                        fullWidth
                                        margin="normal"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                    <Autocomplete
                                        multiple
                                        options={fileExtensionOptions}
                                        value={extension.split(',').map(e => e.trim()).filter(Boolean)}
                                        onChange={(event, newValue) => setExtension(newValue.join(', '))}
                                        renderInput={(params) => (
                                            <TextField {...params} label="გაფართოება" margin="normal" fullWidth />
                                        )}
                                        freeSolo
                                    />

                                    <div style={{marginBottom: 16}}>
                                        <TextField
                                            label="მაქს. ზომა MB-ში"
                                            fullWidth
                                            margin="normal"
                                            type="number"
                                            value={maxSizeMB}
                                            onChange={handleInputChange}
                                            error={error}
                                            helperText={helperText}
                                            inputProps={{
                                                min: 1,
                                                max: 10000
                                            }}
                                        />

                                    </div>
                                    <FormControl fullWidth>
                                        <InputLabel>ქალაქი</InputLabel>
                                        <Select
                                            label="ქალაქი"
                                            value={selectedCityId}
                                            onChange={(e) => setSelectedCityId(e.target.value)}
                                        >
                                            <MenuItem value={null}>
                                                <em>აირჩიეთ ქალაქი</em>
                                            </MenuItem>
                                            {cities.map((city) => (
                                                <MenuItem key={city.id} value={city.id}>
                                                    {city.itemName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isRequired}
                                                disabled={isCheck}
                                                onChange={(e) => setIsRequired(e.target.checked)}
                                            />
                                        }
                                        label="სავალდებულო"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isCheck}
                                                onChange={(e) => {
                                                    setIsCheck(e.target.checked);
                                                    if (e.target.checked) {
                                                        setIsRequired(true);
                                                        setIsInspectDocument(false)
                                                        setIsInspectCertificate(false)
                                                    }
                                                }}
                                            />
                                        }
                                        label="დაჩქარების ქვითარი"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isInspectDocument}
                                                onChange={(e) => {
                                                    setIsInspectDocument(e.target.checked);
                                                    if (e.target.checked) {
                                                        setIsCheck(false)
                                                        setIsInspectCertificate(false)
                                                    }
                                                }}
                                            />
                                        }
                                        label="ინსპექტირების ოქმი"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isInspectCertificate}
                                                onChange={(e) => {
                                                    setIsInspectCertificate(e.target.checked);
                                                    if (e.target.checked) {
                                                        setIsInspectDocument(false)
                                                        setIsCheck(false)
                                                    }
                                                }}
                                            />
                                        }
                                        label="ინსპექტირების სერტიფიკატი"
                                    />

                                    <Button
                                        type="submit"
                                        color="primary"
                                        variant="contained"
                                        style={{marginTop: 16}}
                                        disabled={isSubmitDisabled}
                                    >
                                        დამახსოვრება
                                    </Button>
                                </form>
                            </Paper>

                            <TableContainer component={Paper}
                            >
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>დოკუმენტი სახელი</TableCell>
                                            <TableCell align="left">გაფართოება</TableCell>
                                            <TableCell align="left"> ზომა</TableCell>
                                            <TableCell align="left">სავალდებულო</TableCell>
                                            <TableCell align="left">დაჩქარების ქვითარი</TableCell>
                                            <TableCell align="left">ინსპექტირების ოქმი</TableCell>
                                            <TableCell align="left">ინსპექტირების სერტიფიკატი</TableCell>
                                            <TableCell align="left">ქალაქი</TableCell>
                                            <TableCell align="left">ქმედება</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {isLoading ? (<div style={{minHeight: 800, paddingTop: "25%", minWidth: 1098}}>
                                        <LoaderCustomFixed/></div>) : (
                                        <TableBody>
                                            {fileTypes.map((fileType, index) => (
                                                <TableRow
                                                    key={fileType.id}
                                                    draggable
                                                    onDragStart={(e) => handleDragStart(e, index)}
                                                    onDrop={(e) => handleDrop(e, index)}
                                                    onDragOver={handleDragOver}
                                                    onDragEnter={(e) => handleDragEnter(e, index)}
                                                    onDragLeave={handleDragLeave}
                                                    onDragEnd={handleDragEnd}
                                                    className={`${draggedItem === index ? "row-being-dragged" : ""} ${droppedItem === index ? "row-dropped" : ""} ${dragOverIndex === index ? "drag-over" : ""}`}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {isEditing === fileType.id ? (
                                                            <TextField
                                                                value={editableFileType.title}
                                                                onChange={(e) => setEditableFileType({
                                                                    ...editableFileType,
                                                                    title: e.target.value
                                                                })}
                                                                fullWidth
                                                            />
                                                        ) : (
                                                            fileType.title
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {isEditing === fileType.id ? (
                                                            <TextField
                                                                value={editableFileType.extension.split(',').map(ext => ext.trim().startsWith('.') ? ext.trim().substring(1) : ext.trim()).join(', ')}
                                                                onChange={(e) => setEditableFileType({
                                                                    ...editableFileType,
                                                                    extension: e.target.value
                                                                })}
                                                                fullWidth
                                                            />
                                                        ) : (
                                                            fileType.extension.split(',').map(ext => ext.trim().startsWith('.') ? ext.trim().substring(1) : ext.trim()).join(', ')
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {isEditing === fileType.id ? (
                                                            <TextField
                                                                type="number"
                                                                value={editableFileType.maxSizeMB}
                                                                onChange={(e) => setEditableFileType({
                                                                    ...editableFileType,
                                                                    maxSizeMB: e.target.value
                                                                })}
                                                                fullWidth
                                                            />
                                                        ) : (
                                                            `${fileType.maxSizeMB} MB`
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {isEditing === fileType.id ? (
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        checked={editableFileType.required}
                                                                        onChange={(e) => setEditableFileType({
                                                                            ...editableFileType,
                                                                            required: e.target.checked
                                                                        })}
                                                                    />
                                                                }
                                                                label={editableFileType.required ? "კი" : "არა"}
                                                            />
                                                        ) : (
                                                            fileType.required ? "კი" : "არა"
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {isEditing === fileType.id ? (
                                                            fileType.isCheck ? "კი" : "არა"
                                                        ) : (
                                                            fileType.isCheck ? "კი" : "არა"
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {fileType.registeryDocumentType === 1 ? "კი" : "არა"}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {fileType.isinspectionSertificate ? "კი" : "არა"}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {isEditing === fileType.id ? (
                                                            <FormControl fullWidth size="small">
                                                                <Select
                                                                    value={editableFileType.cityId || ''}
                                                                    onChange={(e) => setEditableFileType({
                                                                        ...editableFileType,
                                                                        cityId: e.target.value
                                                                    })}
                                                                >
                                                                    <MenuItem value={null}>
                                                                        <em>აირჩიეთ ქალაქი</em>
                                                                    </MenuItem>
                                                                    {cities.map((city) => (
                                                                        <MenuItem key={city.id} value={city.id}>
                                                                            {city.itemName}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        ) : (
                                                            getCityNameById(fileType.cityId)

                                                        )}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {isEditing === fileType.id ? (
                                                            <div style={{display: "flex"}}>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => handleSave(fileType.id)}
                                                                    style={{
                                                                        width: 100,
                                                                        marginRight: 5
                                                                    }}
                                                                >
                                                                    შენახვა
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="secondary"
                                                                    onClick={() => setIsEditing(null)}
                                                                    style={{
                                                                        width: 100,
                                                                    }}
                                                                >
                                                                    გაუქმება
                                                                </Button>

                                                            </div>
                                                        ) : (
                                                            <div style={{display: "flex"}}>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => handleEdit(fileType)}
                                                                    style={{
                                                                        width: 100,
                                                                        marginRight: 5
                                                                    }}
                                                                >
                                                                    რედაქტირება
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="error"
                                                                    onClick={() => openDeleteModal(fileType.id)}
                                                                    style={{width: 100}}
                                                                >
                                                                    წაშლა
                                                                </Button>
                                                            </div>

                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                            }
                                        </TableBody>
                                    )}

                                </Table>
                            </TableContainer>
                        </Container>
                    )
                    :
                    activeTab === 'accelerate' ? (
                            <AddNewPermitTypePrice/>
                        )
                        :
                        (
                            <ContenteditableFields/>
                        )}
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={confirmSubmit}
                />
                <ConfirmationModal
                    isOpen={isDeleteModalOpen}
                    onRequestClose={() => setIsDeleteModalOpen(false)}
                    onConfirm={handleDeleteConfirm}
                />
                {alert.show &&
                    <CustomAlert
                        message={alert.message}
                        type={alert.type}
                        onClose={() => setAlert({...alert, show: false})}
                    />
                }
            </div>
        </div>

    );
};

export default AddNewFileTypeForm;
